import { defineComponent as _defineComponent } from 'vue'
import { ButtonBoxDecide, ListDisplay } from '@warrenbrasil/nebraska-web';
import { Money } from '@/modules/common/components/Money';
interface Props {
  isLoading: boolean;
  balance: string;
  processingWarningText?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeCashSummary',
  props: {
    isLoading: { type: Boolean },
    balance: null,
    processingWarningText: null
  },
  setup(__props: any) {



return { __sfc: true,ButtonBoxDecide, ListDisplay, Money }
}

})